import { Controller } from "@hotwired/stimulus";

// Shows the "new medication" name input only while the select is on
// "new", and DISABLES it otherwise, so a name typed then abandoned is never
// submitted (spec 2026-09-25 §3, Codex Gate 1). With no select (a pharmacy
// with no medications yet) the input is always live.
export default class extends Controller {
  static targets = ["select", "name"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (!this.hasSelectTarget) return;
    const isNew = this.selectTarget.value === "new";
    this.nameTarget.hidden = !isNew;
    this.nameTarget.disabled = !isNew;
    this.nameTarget.required = isNew;
  }
}
